import { createResource } from 'react-resource-router';

import { MergeQueue } from 'src/components/pipelines/models/MergeQueue';
import { fetchData } from 'src/components/pipelines/resources/utils';
import repoUrls from 'src/sections/repository/urls';

import { MergeQueuesResourceResponse, MergeQueueResponse } from './types';

const getMergeQueuesUrl = (
  repositoryOwner: string,
  repositorySlug: string,
  page: string = '1'
) => {
  return repoUrls.api.internal.mergeQueues(repositoryOwner, repositorySlug, {
    page,
  });
};

export const mergeQueuesRouteResource =
  createResource<MergeQueuesResourceResponse>({
    type: 'mergeQueues',
    getKey: ({ match, query }) => {
      return getMergeQueuesUrl(
        match.params.repositoryOwner!,
        match.params.repositorySlug!,
        query.page
      );
    },
    maxAge: 60000,
    getData: async ({ match, query }) => {
      const apiBaseUrl = getMergeQueuesUrl(
        match.params.repositoryOwner!,
        match.params.repositorySlug!,
        query.page
      );

      const mergeQueues = await fetchData(
        apiBaseUrl,
        'merge_queues_resource_exception'
      );

      return {
        page: mergeQueues.page,
        pagelen: mergeQueues.pagelen,
        size: mergeQueues.size,
        values: mergeQueues.values.map(
          (mergeQueue: MergeQueueResponse) => new MergeQueue(mergeQueue)
        ),
      };
    },
  });
